import React, { useState } from 'react';
import { UsersIcon } from '@heroicons/react/24/outline';
import { ExportCard } from '../ExportCard';
import { exportCollaboratorsList } from '../../services';

interface CollaboratorsListExportCardProps {
    onError: (message: string | null) => void;
}

/**
 * Listagem completa de colaboradores: situação, senioridade, habilidade
 * principal, vínculo, datas de admissão e demissão, líder técnico e cliente.
 */
export const CollaboratorsListExportCard: React.FC<CollaboratorsListExportCardProps> = ({
    onError,
}) => {
    const [isExporting, setIsExporting] = useState(false);

    const handleExport = async () => {
        setIsExporting(true);
        onError(null);

        try {
            const rowCount = await exportCollaboratorsList();

            if (rowCount === 0) {
                onError('Nenhum colaborador encontrado para exportar.');
            }
        } catch (error) {
            console.error('Erro ao exportar lista de colaboradores:', error);
            onError('Falha ao gerar a listagem de colaboradores. Tente novamente.');
        } finally {
            setIsExporting(false);
        }
    };

    return (
        <ExportCard
            title="Colaboradores (Lista Completa)"
            description="Situação, senioridade, habilidade principal, vínculo, admissão, demissão, líder técnico e cliente alocado."
            icon={UsersIcon}
            isExporting={isExporting}
            onExport={handleExport}
        />
    );
};

export default CollaboratorsListExportCard;
